















import { Component, Prop, Inject, Watch, Vue } from 'vue-property-decorator';
@Component({
  name: 'app',
  components: {}
})
export default class App extends Vue {
  open = false;
}
